// extracted by mini-css-extract-plugin
module.exports = {"shapeWrapper":"styles-module--shapeWrapper--vAjjJ","shape":"styles-module--shape--8f9Oa","circle":"styles-module--circle--2tZWy","triangle":"styles-module--triangle--1wV2k"};